import { render, staticRenderFns } from "./dictList.vue?vue&type=template&id=2e837f99"
import script from "./dictList.vue?vue&type=script&lang=js"
export * from "./dictList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports